<!-- <div class="relative">
    <img (click)="togglePopup($event)" [class]="image_class" [src]="image" alt="">
    <div *ngIf="isPopupOpen" [style.left.px]="buttonX" [style.top.px]="buttonY"
        class="fixed z-[10]">
        <ng-content></ng-content>
    </div>
</div> -->

<!-- <div class="relative inline-block text-left">
  <div #menuBtn (click)="toggleDropdown()">
     <img (click)="togglePopup($event)" [class]="image_class" [src]="image" alt="">
  </div>

  <div *ngIf="isPopupOpen"
       #menuDropdown
       class="absolute right-0 z-[11] transition-all duration-200">
     <ng-content></ng-content>
  </div>
</div> -->



<button mat-icon-button [matMenuTriggerFor]="menu" class="flex justify-center items-center">
   <img [class]="image_class" [src]="image" alt="">
</button>
<mat-menu #menu="matMenu" class="no-padding-menu">
  <ng-content></ng-content>
</mat-menu>